import { Link } from "@tanstack/react-router";
import { Phone, Clock, FileBadge } from "lucide-react";
import logo from "@/assets/logo.asset.json";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/contact", label: "Contact" },
] as const;

export function Footer() {
  return (
    <footer className="bg-surface-alt mt-0">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-8 text-center md:text-left">
          <nav className="flex flex-wrap justify-center md:justify-start gap-5">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                className="font-display font-semibold uppercase text-sm text-ink hover:text-brand"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="flex justify-center">
            <Link to="/">
              <img src={logo.url} alt="Homestead Construction of NEA" className="h-16 w-auto" />
            </Link>
          </div>

          <div className="text-sm text-ink/70 md:text-right">
            All Rights Reserved &copy; 2026
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-ink/10 grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-ink/70 text-center md:text-left">
          <div className="flex items-center justify-center md:justify-start gap-2">
            <Phone className="h-4 w-4 text-brand" />
            <a href="tel:5015936361" className="hover:text-brand">501-593-6361</a>
          </div>
          <div className="flex items-center justify-center gap-2">
            <Clock className="h-4 w-4 text-brand" />
            Mon - Fri 7am - 5pm
          </div>
          <div className="flex items-center justify-center md:justify-end gap-2">
            <FileBadge className="h-4 w-4 text-brand" />
            License #0450850225
          </div>
        </div>
      </div>
    </footer>
  );
}
